// loading.interceptor.ts
import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { EMPTY, catchError, finalize, throwError } from 'rxjs';
import { LoaderService } from './loader-service';
import { LoginService } from '@/app/services/login.service';
import { isUnauthorizedSessionError } from '@/app/services/interceptor/session-expiration-error';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loader = inject(LoaderService);
  const loginService = inject(LoginService);

  if (loginService.logoutIfLoginTimeExpired()) {
    return EMPTY;
  }

  loader.show();

  return next(req).pipe(
    catchError((error: unknown) => {
      const isExpiredSessionError =
        error instanceof HttpErrorResponse && isUnauthorizedSessionError(error.status);

      if (isExpiredSessionError) {
        loginService.logoutExpiredSession();
        return EMPTY;
      }

      return throwError(() => error);
    }),
    finalize(() => loader.hide())
  );
};
